import { render, staticRenderFns } from "./UISelect.vue?vue&type=template&id=35dbf17d&scoped=true&"
import script from "./UISelect.vue?vue&type=script&lang=js&"
export * from "./UISelect.vue?vue&type=script&lang=js&"
import style0 from "./UISelect.vue?vue&type=style&index=0&id=35dbf17d&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dbf17d",
  null
  
)

export default component.exports